/**
 * Users API (Admin) — CRUD, credentials, seed, reset password.
 */

import { apiFetch } from './core'

export async function apiListUsers() {
    return apiFetch('/users')
}

export async function apiCreateUser(userData) {
    return apiFetch('/users', {
        method: 'POST',
        body: JSON.stringify(userData),
    })
}

export async function apiUpdateUser(userId, userData) {
    return apiFetch(`/users/${userId}`, {
        method: 'PUT',
        body: JSON.stringify(userData),
    })
}

export async function apiDeleteUser(userId) {
    await apiFetch(`/users/${userId}`, { method: 'DELETE' })
}

export async function apiSeedEmployeeAccounts() {
    return apiFetch('/auth/seed-employee-accounts', { method: 'POST' })
}

export async function apiGetCredentials() {
    return apiFetch('/users/credentials')
}

export async function apiReseedLogins() {
    return apiFetch('/auth/reseed-logins', { method: 'POST' })
}

export async function apiResetPassword(userId) {
    return apiFetch(`/users/${userId}/reset-password`, { method: 'POST' })
}

/**
 * Выдать одноразовую ссылку «задайте себе пароль».
 * Гасит текущий пароль: войти по нему больше нельзя. Уже открытая сессия
 * при этом доживает до истечения токена — мгновенного отзыва доступа нет.
 */
export async function apiCreateInvite(userId) {
    return apiFetch(`/users/${userId}/invite`, { method: 'POST' })
}

/**
 * Завести подрядчику логин со страницы «Управление доступами».
 * Отдельный путь от `/contractors/{id}/account`: тот роутер закрыт модулем
 * «Подрядчики», недоступным с этой страницы. Временный пароль возвращается
 * ОДИН раз — в базе он лежит только хешем, повторно показать его нельзя.
 */
export async function apiProvisionContractorAccount(contractorId) {
    return apiFetch(`/users/contractors/${contractorId}/account`, { method: 'POST' })
}

/** Незакрытые заявки «забыл пароль» — для «Управления доступами». */
export async function apiListPasswordResetRequests() {
    return apiFetch('/password-reset-requests')
}

/**
 * Сводка каналов восстановления: у кого ссылка уйдёт автоматически, а кто
 * придёт заявкой. Нужна, чтобы адресно дожать привязку Telegram.
 */
export async function apiPasswordResetChannelsHealth() {
    return apiFetch('/password-reset-requests/channels-health')
}

/** Закрыть заявку — после выдачи ссылки или как «разобрался сам». */
export async function apiResolvePasswordResetRequest(requestId) {
    return apiFetch(`/password-reset-requests/${requestId}/resolve`, { method: 'POST' })
}

/** Пакетная выдача ссылок — «пригласить всех, кто не заходил». */
export async function apiCreateInvitesBulk(userIds) {
    return apiFetch('/users/invite-bulk', {
        method: 'POST',
        body: JSON.stringify({ user_ids: userIds }),
    })
}

/**
 * Отвязать User от Employee (для merge с удалением карточки).
 * По умолчанию также деактивирует аккаунт.
 */
export async function apiDetachUserEmployee(userId, { deactivate = true } = {}) {
    const qs = deactivate === false ? '?deactivate=false' : ''
    return apiFetch(`/users/${userId}/detach-employee${qs}`, { method: 'POST' })
}
